module.exports = __webpack_public_path__ + "img/box_jean.e85153b3.webp";